export enum SearchServiceState {
  Idle = 'idle',
  Typing = 'typing',
  Loading = 'loading',
  Success = 'success',
  Error = 'error',
}
